export default "__VITE_ASSET__Bmmqu9I9__"